import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import classNames from 'classnames';
export default class MultiSelectWrapper extends React.Component {

  state = { value: [] };

  componentWillMount = () => {
    this.setState({value: this.props.value})
  };

  componentWillReceiveProps = newProps => {
    this.setState({value: newProps.value, errors: newProps.errors})
  };


  handleChange = data => {
    console.log('data', data);
   this.props.handleChange({[this.props.name]: data});
  };

  getValue = () => {
    let res = '';
    this.state.value.forEach(el => {
      res = el.value + ',' + res
    });
    return res;
  };


  render(){
    return(
      <div className={classNames('multiselect', {hasError: this.state.errors} )}>
      <Select
        openOnFocus={true}
        multi={true}
        placeholder={this.props.placeholder}
        name={this.props.placeholder}
        value={this.getValue()}
        options={this.props.elements}
        onChange={this.handleChange}
      />
        {this.state.errors &&
          <span className="error">{this.state.errors}</span>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/MultiSelectWrapper.jsx